module.exports = __webpack_public_path__ + "static/media/boombox.f39410a0.svg";